import { observable, action } from 'mobx';

export class CommonStore {

    @observable appLoaded = false;
    @observable snackbarOptions = {
        open: false,
        message: ''
    };
    @observable dialogOptions = {
        dialogOpen: false,
        type: ''
    }
    @observable currentStore = '';  //current store to keep track
    @observable goodToGo = false;
    @observable noNet = false;
    @observable activeTab = "Drafts"
    @observable helpDialog = false;

    @action openHelpDialog(value) {
        this.helpDialog = value
    }

    @action setActiveTab(active) {
        this.activeTab = active
    }

    @action openTrashFlag() {
        this.openTrash = true;
    }
    @action closeTrashFlag() {
        this.openTrash = false;
    }
    @action setAppLoaded() {
        this.appLoaded = true;
    }

    @action modifyText = (text) => {
        let temp = []
        text.split("_").length && text.split("_").forEach(word => {
            word = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            temp.push(word)
        })
        return temp.join(" ")
    }

    @action handleOpenSnackBar(message, type) {
        this.snackbarOptions.open = true;
        this.snackbarOptions.message = message;
        this.snackbarOptions.type = type;
    }

    @action handleCloseSnackBar() {
        this.snackbarOptions.open = false;
        this.snackbarOptions.message = '';
    }

    @action openDialog(dialogType) {
        this.dialogOptions.dialogOpen = true;
        this.dialogOptions.type = dialogType;
    }

    @action closeDialog() {
        this.dialogOptions.dialogOpen = false;
        this.dialogOptions.type = '';
    }

    @action setCurrentStore(storeValue) {
        this.goodToGo = true;
        this.currentStore = storeValue;
    }
    @action resetFlag() {
        this.goodToGo = false;
    }

    @action setNoInternet() {
        this.noNet = true;
    }
    @action resetNoInternet() {
        this.noNet = false;
    }

}
export default new CommonStore();
